import { Repeat } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { StoreProductSchedule } from '@nucleus-commerce/api-client/admin';
import { Alert, AlertDescription, AlertTitle } from '@nucleus-commerce/ui/components/alert';

import { ScheduleLink, ScheduleOwnerBadge } from './schedule-owner-badge';

/**
 * A rotation owns this store product (decision 11 of D-181): its runs set the status, so a
 * manual publish or unpublish holds only until the next run, unless the product is excluded from
 * the rotation's pool. One-shot dates are refused while it owns the row.
 */
export function ScheduleOwnerBanner({ schedule }: { schedule: StoreProductSchedule }) {
  const { t } = useTranslation('storeCatalog');
  return (
    <Alert role="status">
      <Repeat aria-hidden />
      <AlertTitle className="flex flex-wrap items-center gap-2">
        <span>
          {t('owner.title')} <ScheduleLink schedule={schedule} className="underline" />
        </span>
        <ScheduleOwnerBadge schedule={schedule} />
      </AlertTitle>
      <AlertDescription>
        <p>{t(`owner.state.${schedule.state}`)}</p>
        <p>{t('owner.manual')}</p>
      </AlertDescription>
    </Alert>
  );
}
